import React from 'react';
import { SmileySad } from '@phosphor-icons/react';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';

import { Button, Modal } from '../../components/general';

import { URL } from '../../constants';
import { getHelpUrl } from '../../utils';

interface Props {
  show: boolean;
  heading?: string;
  subheading?: string | React.ReactNode;
  btn?: React.ReactNode;
  isTryAgainBtn?: boolean;
  isContactUs?: boolean;
}

const ErrorModal: React.FC<Props> = (props) => {
  const { show, heading, subheading, btn, isTryAgainBtn, isContactUs } = props;

  const navigate = useNavigate();

  return (
    <Modal show={show}>
      <Modal.Body centered>
        <SmileySad
          weight="fill"
          className="fill-[url('#icon-primary-gradient')]"
          size={100}
        />

        {heading && <h4>{parse(heading)}</h4>}

        {subheading && <div>{subheading}</div>}

        {!!btn ? (
          btn
        ) : isTryAgainBtn ? (
          <Button className="w-full" onClick={() => window.location.reload()}>
            Try Again
          </Button>
        ) : (
          <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4">
            <Button
              className="w-full sm:w-1/2"
              onClick={() => navigate(URL.HOME)}
            >
              Return Home
            </Button>

            <Button
              colour="pink"
              className="w-full sm:w-1/2"
              onClick={() => navigate(getHelpUrl())}
            >
              Help
            </Button>
          </div>
        )}

        {isContactUs && (
          <div className="text-sm italic">
            Need help? Contact us at{' '}
            <a href="mailto:hello@crowdclip.com">hello@crowdclip.com</a>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;
